module.exports = __webpack_public_path__ + "static/img/port.0dac3ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/hardProduct/images/port.png
// module id = X5Zi
// module chunks = 1